import Footer from "../../footer"
import NavBar from "../../nav"

const SafetyStandard = () => {
  return <div className='all-manuals'>
    <NavBar />
    <div>
	<section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>The Fly Compliant Safety Standard</h1>
				<div className="headline-divider sections"></div>
				<h2>Continually Evolving Practices</h2>
			</div>
		</section>
		<section className="clean-block clearfix">
			<div className="container content-container about-container">
				<div className="prose">Fly Compliant, LLC has developed a Safety Standard defining minimum criteria for participating members. The core of the standard is the <a href="https://www.levelflight.com" target="_blank" rel="noreferrer">www.LevelFight.com</a> Safety Management System (SMS). Fly Compliant, LLC has developed a <a href="/safety/safety-board">Safety Board</a> to review as a group reported SMS events and mitigation strategies to develop best practices for participating members. This is a proactive approach to safety for a group of operators working in concert to operate transparently.</div>
				<div className="prose not-first">A control for this group is the Automated Risk Assessment (ARA). Fly Compliant, LLC has developed <a href="https://www.levelflight.com" target="_blank" rel="noreferrer">www.LevelFight.com</a> and within the LevelFlight SMS is the proprietary ARA. The ARA is an objective approach to mitigating risk by determining the risk from inputs and producing an objective risk score. The ARA will define the risk through the ARA audit. This is part of the transparency of our system so all concerned are able review associated risk.</div>	
				<div className="prose not-first"><a href="/contact-us/safety-standard" rel="noreferrer" >Contact us</a> for a copy of our Safety Standard.</div>				
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default SafetyStandard